
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password-success",
      function () {
        return require("private-next-pages/password-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password-success"])
      });
    }
  